import { Component, OnInit } from '@angular/core';
import 'jquery';
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  clnm:string='';
  clcd:any;
  logopath:any;
  constructor() { 
    this.clcd=localStorage.getItem('clcd');
    this.logopath="assets/images/"+this.clcd+".png";
  }

  ngOnInit(): void {
    this.clnm=localStorage.getItem('clnm');
    $.AdminBSB.leftSideBar.activate();
   
  }

}
